import { render, staticRenderFns } from "./MyTests.vue?vue&type=template&id=fdb47d20&scoped=true&"
import script from "./MyTests.vue?vue&type=script&lang=js&"
export * from "./MyTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb47d20",
  null
  
)

export default component.exports